import { BulkDialer4L, Dialer4L } from "./dialer"
import useGlobalStore from "~/store/global"
import useVoiceSessionStore from "~/store/voice-session"

export default function VoiceDialerHost() {
  const enabled = useGlobalStore(
    (s) => s.user?.feature_flags?.voice_dialer_enabled
  )
  const bulkPeople = useVoiceSessionStore((s) => s.bulkPeople)
  const single = useVoiceSessionStore((s) => s.single)
  const closeBulk = useVoiceSessionStore((s) => s.closeBulk)
  const closeSingle = useVoiceSessionStore((s) => s.closeSingle)

  if (!enabled) return null
  if (!bulkPeople && !single) return null

  return (
    <div className="voice-dialer-root">
      {single && (
        <Dialer4L person={single} onClose={closeSingle} onLogCall={() => {}} />
      )}
      {bulkPeople && (
        <BulkDialer4L
          people={bulkPeople}
          onClose={closeBulk}
          onLogCall={() => {}}
          onEnrich={() => {}}
        />
      )}
    </div>
  )
}
